import store from "../store/store";

export default {
  data () {
    return {
      // NOTE: these were previously named with a leading underscore
      // (_syncDebounceTimer/_syncDebounceMs). Vue 2 does NOT proxy data keys
      // that start with "_" or "$" onto the instance, so `this._syncDebounceTimer`
      // was always undefined and the debounce/teardown never actually worked.
      // Renamed (Phase 5) so the debounce and its cleanup function correctly.
      syncDebounceTimer: null,
      syncDebounceMs: 400
    };
  },
  beforeDestroy () {
    // Phase 5 leak fix: clear any pending debounced sync when the component is
    // torn down so the timer cannot fire against a destroyed instance.
    if (this.syncDebounceTimer) {
      clearTimeout(this.syncDebounceTimer);
      this.syncDebounceTimer = null;
    }
  },
  methods: {
    // NOTE: previously defined at the root of the mixin object rather than under
    // `methods`, which meant Vue never registered it as a component method.
    // Moved into `methods` (Phase 5) so it is actually callable.
    async saveAndStartSyncing (order) {
      store.dispatch("orders/saveOrder", order);
      // Debounce sync to prevent duplicate API calls during rapid edits
      if (this.syncDebounceTimer) {
        clearTimeout(this.syncDebounceTimer);
      }
      this.syncDebounceTimer = setTimeout(() => {
        this.syncDebounceTimer = null;
        store.dispatch("sync")
            .then(() => null)
            .catch((err) => {
              console.warn("[SyncMixin] Background sync failed (likely offline)", err);
            });
      }, this.syncDebounceMs);
    }
  }
};
